import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { Grid } from '@material-ui/core';
import get from 'lodash/get';

import DCUrl from '@hydra/routes/crawler/utils/DCUrl';
import DCUrlLabel from '@hydra/routes/crawler/components/DCUrlLabel';

export class BrokenHreflangIssuesRow extends React.Component {
  static propTypes = {
    issue: PropTypes.object,
    columnStyles: PropTypes.array,
    relay: PropTypes.object
  }

  render () {
    const {
      columnStyles,
      issue,
      className: classNameProp
    } = this.props;

    const domain = get(this.props, ['relay', 'route', 'params', 'url'], '');
    const issueUrl = new DCUrl(domain, issue.url);
    const sourceUrl = new DCUrl(domain, issue.source_url);

    return (
      <Grid container className={classNameProp} alignItems='flex-start'>
        <Grid item {...columnStyles[0]}>
          <DCUrlLabel url={issueUrl} severity='error' />
        </Grid>
        <Grid item {...columnStyles[1]}>
          <DCUrlLabel url={sourceUrl} severity={issue.severity} />
        </Grid>
      </Grid>
    );
  }
}

export default createFragmentContainer(BrokenHreflangIssuesRow, {
  issue: graphql`
    fragment BrokenHreflangIssuesRow_issue on BrokenHreflang {
      id
      type
      severity
      url
      source_url
    }
  `
});
